import React from 'react';
import { ChevronDown, Code, Zap, Star } from 'lucide-react';
import { personalInfo, projects } from '../../mock/data';
import { getCurrentSemester, getYearsSince, formatOrdinal, yearsWord } from '../../lib/dateUtils';
import './Hero.css';

const Hero = ({ language }) => {
  const semester = getCurrentSemester(personalInfo.startDate);
  const yearsOfExperience = getYearsSince(personalInfo.startDate);

  const scrollToAbout = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-background">
        <div className="grid-pattern"></div>
        <div className="floating-elements">
          <div className="floating-icon floating-icon-1">
            <Code size={24} />
          </div>
          <div className="floating-icon floating-icon-2">
            <Zap size={24} />
          </div>
          <div className="floating-icon floating-icon-3">
            <Star size={24} />
          </div>
        </div>
      </div>

      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className="hero-greeting">
              {language === 'pt' ? 'Olá, eu sou' : 'Hi, I\'m'}
            </div>

            <h1 className="hero-name">
              <span className="name-highlight">Pazzutti</span>
              <div className="name-glow"></div>
            </h1>

            <div className="hero-role">
              <span className="typing-text">{language === 'pt' ? 'Desenvolvedor de Software' : 'Software Developer'}</span>
              <span className="cursor" aria-hidden="true">|</span>
            </div>

            <p className="hero-description">
              {language === 'pt' 
                ? 'Estudante de Engenharia de Software na PUC Minas e estagiário apaixonado por criar soluções inovadoras e colocar a mão na massa.'
                : 'Software Engineering student at PUC Minas and intern passionate about creating innovative solutions and getting hands-on experience.'
              }
            </p>

            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-number">{formatOrdinal(semester, language)}</div>
                <div className="stat-label">
                  {language === 'pt' ? 'Período' : 'Semester'}
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-number">{yearsOfExperience}+</div>
                <div className="stat-label">
                  {language === 'pt'
                    ? `${yearsWord(yearsOfExperience, 'pt')} de Experiência`
                    : `${yearsWord(yearsOfExperience, 'en')} of Experience`
                  }
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-number">{projects.length}</div>
                <div className="stat-label">
                  {language === 'pt' ? 'Projetos' : 'Projects'}
                </div>
              </div>
            </div>

            <div className="hero-actions">
              <button 
                className="btn-primary"
                onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}
              >
                {language === 'pt' ? 'Ver Projetos' : 'View Projects'}
              </button>
              <button 
                className="btn-secondary"
                onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
              >
                {language === 'pt' ? 'Sobre Mim' : 'About Me'}
              </button>
              
            </div>
          </div>

          <div className="hero-image">
            <div className="image-container">
              <img 
                src={personalInfo.avatar} 
                alt="Pazzutti"
                className="profile-image"
              />
              <div className="image-glow"></div>
              <div className="code-snippet">
                <div className="code-header">
                  <div className="code-dots">
                    <span className="dot red"></span>
                    <span className="dot yellow"></span>
                    <span className="dot green"></span>
                  </div>
                  <span className="code-title">about.js</span>
                </div>
                <div className="code-content">
                  <div className="code-line">
                    <span className="code-keyword">const</span>{' '}
                    <span className="code-variable">developer</span> = {'{'}
                  </div>
                  <div className="code-line indent">
                    <span className="code-property">name</span>: 
                    <span className="code-string">'Pazzutti'</span>,
                  </div>
                  <div className="code-line indent">
                    <span className="code-property">passion</span>: 
                    <span className="code-string">'coding'</span>,
                  </div>
                  <div className="code-line indent">
                    <span className="code-property">status</span>: 
                    <span className="code-string">'learning'</span>
                  </div>
                  <div className="code-line">{'};'}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button className="scroll-indicator" onClick={scrollToAbout}>
          <ChevronDown size={20} />
          <span>{language === 'pt' ? 'Role para baixo' : 'Scroll down'}</span>
        </button>
      </div>
    </section>
  );
};

export default Hero;